import {EDevicePermissionState} from './device-permissions.enum';

export interface IDevicePermissions extends Object {
  ['camera']: EDevicePermissionState;
  ['clipboard-read']: EDevicePermissionState;
  ['clipboard-write']: EDevicePermissionState;
  ['geolocation']: EDevicePermissionState;
  isDevicePermissionLoading: boolean;
  ['microphone']: EDevicePermissionState;
  ['midi']: EDevicePermissionState;
  ['notifications']: EDevicePermissionState;
  ['persistent-storage']: EDevicePermissionState;
  ['push']: EDevicePermissionState;
  // ['screen-orientation']: EDevicePermissionState;
  ['screen-wake-lock']: EDevicePermissionState;
  ['storage-access']: EDevicePermissionState;
}

export const DEFAULT_DEVICE_PERMISSIONS: Readonly<IDevicePermissions> = {
  ['camera']: EDevicePermissionState.prompt,
  ['clipboard-read']: EDevicePermissionState.prompt,
  ['clipboard-write']: EDevicePermissionState.prompt,
  ['geolocation']: EDevicePermissionState.prompt,
  isDevicePermissionLoading: false,
  ['microphone']: EDevicePermissionState.prompt,
  ['midi']: EDevicePermissionState.prompt,
  ['notifications']: EDevicePermissionState.prompt,
  ['persistent-storage']: EDevicePermissionState.prompt,
  ['push']: EDevicePermissionState.prompt,
  // ['screen-orientation']: EDevicePermissionState.prompt,
  ['screen-wake-lock']: EDevicePermissionState.prompt,
  ['storage-access']: EDevicePermissionState.prompt,
};

